module.exports = __webpack_public_path__ + "static/media/users.bc545494.png";